import React, { useState, createContext, useEffect } from "react";
import { Divider } from "@material-ui/core";
import moment from "moment";
import { useHistory } from "react-router-dom";

import Grid from "../../components/Grid";
import { Card, CardActions } from "../../components/Card";
import Button from "../../components/Button";
import SaleObjFilterTop from "./SaleObjFilterTop";
import SaleObjFilterMiddle from "./SaleObjFilterMiddle";
import SaleObjFilterMiddle2 from "./SaleObjFilterMiddle2";
import SaleObjFilterMiddle3 from "./SaleObjFilterMiddle3";
export const ContextAddressArray = createContext({
  addressArray: [],
  setAddressArray: () => {},
});
export default function GlobalQueryTable() {
  const history = useHistory();
  const headoffice = true;
  const [addressArray, setAddressArray] = useState([]);
  const [newData, setNewData] = useState({
    theCourtArray: [
      {
        label: "臺灣台北地方法院",
        value: "臺灣台北地方法院",
      },
      {
        label: "臺灣新北地方法院",
        value: "臺灣新北地方法院",
      },
      {
        label: "臺灣士林地方法院",
        value: "臺灣士林地方法院",
      },
      {
        label: "臺灣桃園地方法院",
        value: "臺灣桃園地方法院",
      },
      {
        label: "臺灣新竹地方法院",
        value: "臺灣新竹地方法院",
      },
      {
        label: "臺灣苗栗地方法院",
        value: "臺灣苗栗地方法院",
      },
      {
        label: "臺灣臺中地方法院",
        value: "臺灣臺中地方法院",
      },
      {
        label: "臺灣南投地方法院",
        value: "臺灣南投地方法院",
      },
      {
        label: "臺灣彰化地方法院",
        value: "臺灣彰化地方法院",
      },
      {
        label: "臺灣雲林地方法院",
        value: "臺灣雲林地方法院",
      },
      {
        label: "臺灣嘉義地方法院",
        value: "臺灣嘉義地方法院",
      },
      {
        label: "臺灣臺南地方法院",
        value: "臺灣臺南地方法院",
      },
      {
        label: "臺灣橋頭地方法院",
        value: "臺灣橋頭地方法院",
      },
      {
        label: "臺灣高雄地方法院",
        value: "臺灣高雄地方法院",
      },
      {
        label: "臺灣屏東地方法院",
        value: "臺灣屏東地方法院",
      },
      {
        label: "臺灣臺東地方法院",
        value: "臺灣臺東地方法院",
      },
      {
        label: "臺灣花蓮地方法院",
        value: "臺灣花蓮地方法院",
      },
      {
        label: "臺灣宜蘭地方法院",
        value: "臺灣宜蘭地方法院",
      },
      {
        label: "臺灣基隆地方法院",
        value: "臺灣基隆地方法院",
      },
      {
        label: "臺灣澎湖地方法院",
        value: "臺灣澎湖地方法院",
      },
      {
        label: "福建金門地方法院",
        value: "福建金門地方法院",
      },
      {
        label: "福建連江地方法院",
        value: "福建連江地方法院",
      },
    ],
    theCourt: "臺灣臺中地方法院",
    theCourtObject: {
      label: "臺灣臺中地方法院",
      value: "臺灣臺中地方法院",
    },
    mapMode: false,
    cadastral: false,
    photo: false,
    signal: "",
    areaData: [],
    address: "",
    dateStart: moment().format("YYYY-MM-DD"),
    dateEnd: moment().add(3, "months").format("YYYY-MM-DD"),
    bidopening: true,
    winthebid: false,
    shouldbuy: false,
    recentlyAddedStart: null,
    recentlyAddedEnd: null,
    addedtoday: false,
    searchTerm: "",
    jianpingStart: "",
    jianpingEnd: "",
    floorStart: "",
    floorEnd: "",
    unitPriceJianpingStart: "",
    unitPriceJianpingEnd: "",
    unitPriceFloorStart: "",
    unitPriceFloorEnd: "",
    basePriceStart: "",
    basePriceEnd: "",
    typeLand: [],
    typeLandArray: ["土地", "建物"],
    typeLandHeadofficeArray: [
      {
        label: "全選",
        value: "ALL",
      },
      {
        label: "透天",
        value: "ALLOVERTHESKY",
      },
      {
        label: "樓店",
        value: "SHOP",
      },
      {
        label: "廠房",
        value: "FACTORYBUILD",
      },
      {
        label: "平房",
        value: "BUNGALOW",
      },
      {
        label: "地下室",
        value: "BASEMENT",
      },
      {
        label: "華廈",
        value: "HUAXIA",
      },
      {
        label: "公寓",
        value: "APARTMENTS",
      },
      {
        label: "套房",
        value: "SUITE",
      },
      {
        label: "辦公",
        value: "OFFICE",
      },
      {
        label: "含車位",
        value: "INCLUDINGPARKINGSPACE",
      },
      {
        label: "其他",
        value: "其他",
      },
    ],
    typeBuildArray: [
      {
        label: "透天",
        value: "ALLOVERTHESKY",
      },
      {
        label: "樓店",
        value: "SHOP",
      },
      {
        label: "廠房",
        value: "FACTORYBUILD",
      },
      {
        label: "平房",
        value: "BUNGALOW",
      },
      {
        label: "地下室",
        value: "BASEMENT",
      },
      {
        label: "華廈",
        value: "HUAXIA",
      },
      {
        label: "公寓",
        value: "APARTMENTS",
      },
      {
        label: "套房",
        value: "SUITE",
      },
      {
        label: "辦公",
        value: "OFFICE",
      },
      {
        label: "含車位",
        value: "INCLUDINGPARKINGSPACE",
      },
    ],
    auArray: [],
    typeArray: [],
    auctionsArray: [
      {
        label: "全部拍次",
        value: "ALL",
      },
      {
        label: "1拍",
        value: "1",
      },
      {
        label: "2拍",
        value: "2",
      },
      {
        label: "3拍",
        value: "3",
      },
      {
        label: "4拍",
        value: "4",
      },
      {
        label: "5拍",
        value: "5",
      },
      {
        label: "6拍",
        value: "6",
      },
      {
        label: "7拍",
        value: "7",
      },
      {
        label: "8拍",
        value: "8",
      },
      {
        label: "9拍",
        value: "9",
      },
      {
        label: "10拍",
        value: "10",
      },
    ],
    auctions: [],
    landRightsArray: [
      {
        label: "不分",
        value: "null",
      },
      {
        label: "全部",
        value: "全部",
      },
      {
        label: "持分",
        value: "持分",
      },
    ],
    landRights: "null",
    landRightsObject: {
      label: "不分",
      value: "null",
    },
    buildRightsArray: [
      {
        label: "不分",
        value: "null",
      },
      {
        label: "全部",
        value: "全部",
      },
      {
        label: "持分",
        value: "持分",
      },
    ],
    buildRights: "null",
    buildRightsObject: {
      label: "不分",
      value: "null",
    },
    pointHandArray: [
      {
        label: "不分",
        value: "null",
      },
      {
        label: "點交",
        value: "1",
      },
      {
        label: "不點交",
        value: "0",
      },
      {
        label: "其他",
        value: "2",
      },
    ],
    pointHand: "null",
    pointHandObject: {
      label: "不分",
      value: "null",
    },
    sourceOfTheCaseArray: [
      {
        label: "不分",
        value: "NOT",
      },
      {
        label: "司法院",
        value: "JUDICIALCOURT",
      },
      {
        label: "台灣金服",
        value: "TAIWANFINANCIALSERVICES",
      },
      {
        label: "榮服處",
        value: "HONORSERVICEOFFICE",
      },
      {
        label: "國有財務局",
        value: "STATEOWNEDFINANCEBUREAU",
      },
      {
        label: "台灣糖業",
        value: "TAIWANSUGAR",
      },
    ],
    sourceOfTheCase: "不分",
    sourceOfTheCaseObject: {
      label: "不分",
      value: "NOT",
    },
    roadConditionArray: [
      {
        label: "不分",
        value: "null",
      },
      {
        label: "臨路",
        value: "臨路",
      },
      {
        label: "無臨路",
        value: "無臨路",
      },
    ],
    roadCondition: "null",
    roadConditionObject: {
      label: "不分",
      value: "null",
    },
    latestArray: [
      {
        label: "投標日",
        value: "DATE",
      },
      {
        label: "拍次",
        value: "OBJ_TIME",
      },
      {
        label: "底標價",
        value: "OBJ_PRICE",
      },
    ],
    latest: {
      label: "投標日",
      value: "DATE",
    },
    page: 1,
    pageMax: null,
    pageSize: { label: "100筆", value: "100" },
    pageArray: [
      {
        label: "100筆",
        value: "100",
      },
      {
        label: "200筆",
        value: "200",
      },
    ],
    data: [],
    respondBuy: "",
  });

  function changeDataListener(key, v) {
    if (key === "addedtoday") {
      if (!!v) {
        changeData(
          "recentlyAddedStart",
          moment(new Date()).format("YYYY-MM-DD")
        );
        changeData("recentlyAddedEnd", moment(new Date()).format("YYYY-MM-DD"));
      } else {
        changeData("recentlyAddedStart", null);
        changeData("recentlyAddedEnd", null);
      }
    }
  }
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  useEffect(() => {
    const newSelect = [];
    for (let i = 0; i < newData.auctionsArray.length; i++) {
      newSelect.push(newData.auctionsArray[i]);
    }
    changeData("auArray", newSelect);
  }, []);
  return (
    <Card>
      <CardActions>
        <ContextAddressArray.Provider value={{ addressArray, setAddressArray }}>
          <SaleObjFilterTop
            global
            mapMode={newData.mapMode}
            onChangeMapMode={() =>
              changeData("mapMode", !newData.mapMode, true)
            }
            cadastral={newData.cadastral}
            onChangeCadastral={() =>
              changeData("cadastral", !newData.cadastral, true)
            }
            photo={newData.photo}
            onChangePhoto={() => changeData("photo", !newData.photo, true)}
            signal={newData.signal}
            onChangeSignal={(value) => changeData("signal", value, true)}
            areaData={newData.areaData}
            onChangeAreaData={(value) => {
              const hasAreaData = newData.areaData.find(
                (item) => item.value === value.value
              );
              if (hasAreaData) {
                changeData(
                  "areaData",
                  newData.areaData.filter((i) => i.value !== value.value),
                  true
                );
              } else {
                newData.areaData.push(value);
                changeData("areaData", newData.areaData, true);
              }
            }}
            address={newData.address}
            onChangeAddress={(value) => changeData("address", value, true)}
            dateStart={newData.dateStart}
            onChangeDateStart={(value) => changeData("dateStart", value, true)}
            dateEnd={newData.dateEnd}
            onChangeDateEnd={(value) => changeData("dateEnd", value, true)}
            bidopening={newData.bidopening}
            onChangeBidopening={() =>
              changeData("bidopening", !newData.bidopening, true)
            }
            winthebid={newData.winthebid}
            onChangeWinthebid={() =>
              changeData("winthebid", !newData.winthebid, true)
            }
            shouldbuy={newData.shouldbuy}
            onChangeShouldbuy={() =>
              changeData("shouldbuy", !newData.shouldbuy, true)
            }
            recentlyAddedStart={newData.recentlyAddedStart}
            onChangeRecentlyAddedStart={(value) => {
              changeData(
                "recentlyAddedEnd",
                moment(new Date()).format("YYYY-MM-DD")
              );
              changeData("recentlyAddedStart", value, true);
            }}
            recentlyAddedEnd={newData.recentlyAddedEnd}
            onChangeRecentlyAddedEnd={(value) =>
              changeData("recentlyAddedEnd", value, true)
            }
            addedtoday={newData.addedtoday}
            onChangeAddedtoday={() => {
              changeData("addedtoday", !newData.addedtoday, true);
            }}
            searchTerm={newData.searchTerm}
            onChangeSearchTerm={(value) =>
              changeData("searchTerm", value, true)
            }
          />
        </ContextAddressArray.Provider>
      </CardActions>
      <Divider />
      <CardActions>
        <SaleObjFilterMiddle
          jianpingStart={newData.jianpingStart}
          onChangeJianpingStart={(value) =>
            changeData("jianpingStart", value, true)
          }
          jianpingEnd={newData.jianpingEnd}
          onChangeJianpingEnd={(value) =>
            changeData("jianpingEnd", value, true)
          }
          floorStart={newData.floorStart}
          onChangeFloorStart={(value) => changeData("floorStart", value, true)}
          floorEnd={newData.floorEnd}
          onChangeFloorEnd={(value) => changeData("floorEnd", value, true)}
          unitPriceJianpingStart={newData.unitPriceJianpingStart}
          onChangeUnitPriceJianpingStart={(value) =>
            changeData("unitPriceJianpingStart", value, true)
          }
          unitPriceJianpingEnd={newData.unitPriceJianpingEnd}
          onChangeUnitPriceJianpingEnd={(value) =>
            changeData("unitPriceJianpingEnd", value, true)
          }
          unitPriceFloorStart={newData.unitPriceFloorStart}
          onChangeUnitPriceFloorStart={(value) =>
            changeData("unitPriceFloorStart", value, true)
          }
          unitPriceFloorEnd={newData.unitPriceFloorEnd}
          onChangeUnitPriceFloorEnd={(value) =>
            changeData("unitPriceFloorEnd", value, true)
          }
          basePriceStart={newData.basePriceStart}
          onChangeBasePriceStart={(value) =>
            changeData("basePriceStart", value, true)
          }
          basePriceEnd={newData.basePriceEnd}
          onChangeBasePriceEnd={(value) =>
            changeData("basePriceEnd", value, true)
          }
        />
      </CardActions>
      <Divider />
      <CardActions>
        <SaleObjFilterMiddle2
          headoffice={headoffice}
          auctionsArray={newData.auctionsArray}
          auctions={newData.auctions}
          auArray={newData.auArray}
          respondBuy={newData.respondBuy}
          onChangeRespondBuy={(value) => {
            if (newData.respondBuy === value)
              changeData("respondBuy", "", true);
            else {
              changeData("auArray", []);
              changeData("respondBuy", value, true);
            }
          }}
          onChangeAuctions={(value) => {
            changeData("respondBuy", "");
            changeData("auArray", value, true);
          }}
          typeLandArray={newData.typeLandArray}
          typeLandHeadofficeArray={newData.typeLandHeadofficeArray}
          typeLand={newData.typeLand}
          onChangeTypeLand={(value) => {
            changeData("typeLand", value, true);
          }}
          typeBuildArray={newData.typeBuildArray}
          typeArray={newData.typeArray}
          onChangeTypeArray={(value) => {
            changeData("typeArray", value, true);
          }}
        />
      </CardActions>
      <Divider />
      <CardActions>
        <SaleObjFilterMiddle3
          global
          headoffice={headoffice}
          latestArray={newData.latestArray}
          latest={newData.latest}
          pageArray={newData.pageArray}
          pageSize={newData.pageSize}
          onChangePage={(value) => changeData("pageSize", value, true)}
          onChangeLatest={(value) => changeData("latest", value, true)}
          landRightsArray={newData.landRightsArray}
          landRightsObject={newData.landRightsObject}
          onChangeLandRights={(value) => {
            if (value) {
              changeData("landRights", value.value);
              changeData("landRightsObject", value, true);
            } else {
              changeData("landRights", "不分");
              changeData(
                "landRightsObject",
                { label: "不分", value: "不分" },
                true
              );
            }
          }}
          buildRightsArray={newData.buildRightsArray}
          buildRightsObject={newData.buildRightsObject}
          onChangeBuildRights={(value) => {
            if (value) {
              changeData("buildRights", value.value);
              changeData("buildRightsObject", value, true);
            } else {
              changeData("buildRights", "不分");
              changeData(
                "buildRightsObject",
                { label: "不分", value: "不分" },
                true
              );
            }
          }}
          pointHandArray={newData.pointHandArray}
          pointHandObject={newData.pointHandObject}
          onChangePointHand={(value) => {
            if (value) {
              changeData("pointHand", value.value);
              changeData("pointHandObject", value, true);
            } else {
              changeData("pointHand", "null");
              changeData(
                "pointHandObject",
                { label: "不分", value: "null" },
                true
              );
            }
          }}
          sourceOfTheCaseArray={newData.sourceOfTheCaseArray}
          sourceOfTheCaseObject={newData.sourceOfTheCaseObject}
          onChangeSourceOfTheCase={(value) => {
            if (value) {
              changeData("sourceOfTheCase", value.value);
              changeData("sourceOfTheCaseObject", value, true);
            } else {
              changeData("sourceOfTheCase", "NOT");
              changeData(
                "sourceOfTheCaseObject",
                { label: "不分", value: "NOT" },
                true
              );
            }
          }}
          roadConditionArray={newData.roadConditionArray}
          roadConditionObject={newData.roadConditionObject}
          onChangeRoadCondition={(value) => {
            if (value) {
              changeData("roadCondition", value.value);
              changeData("roadConditionObject", value, true);
            } else {
              changeData("roadCondition", "不分");
              changeData(
                "roadConditionObject",
                { label: "不分", value: "不分" },
                true
              );
            }
          }}
        />
      </CardActions>
      <Divider />
      <Divider />
      <CardActions>
        <Grid container item spacing={1} justify="center">
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onPress={() =>
                history.push(`/console/sale-obj-search-results`, { newData })
              }
            >
              查詢資料
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onPress={() => {
                changeData("theCourt", "臺灣臺中地方法院");
                changeData("theCourtObject", {
                  label: "臺灣臺中地方法院",
                  value: "臺灣臺中地方法院",
                });
                changeData("mapMode", false);
                changeData("cadastral", false);
                changeData("photo", false);
                changeData("signal", "");
                setAddressArray([]);
                changeData("address", "");
                changeData("dateStart", moment().format("YYYY-MM-DD"));
                changeData(
                  "dateEnd",
                  moment().add(3, "months").format("YYYY-MM-DD")
                );
                changeData("bidopening", true);
                changeData("winthebid", false);
                changeData("shouldbuy", false);
                changeData("recentlyAddedStart", null);
                changeData("recentlyAddedEnd", null);
                changeData("addedtoday", false);
                changeData("searchTerm", "");
                changeData("jianpingStart", "");
                changeData("jianpingEnd", "");
                changeData("floorStart", "");
                changeData("floorEnd", "");
                changeData("unitPriceJianpingStart", "");
                changeData("unitPriceJianpingEnd", "");
                changeData("unitPriceFloorStart", "");
                changeData("unitPriceFloorEnd", "");
                changeData("basePriceStart", "");
                changeData("basePriceEnd", "");
                changeData("typeArray", []);
                changeData("typeLand", []);
                changeData("auctions", []);
                changeData("landRights", "null");
                changeData("landRightsObject", {
                  label: "不分",
                  value: "null",
                });
                changeData("buildRights", "null");
                changeData("buildRightsObject", {
                  label: "不分",
                  value: "null",
                });
                changeData("pointHand", "null");
                changeData("pointHandObject", { label: "不分", value: "null" });
                changeData("sourceOfTheCase", "NOT");
                changeData("sourceOfTheCaseObject", {
                  label: "不分",
                  value: "NOT",
                });
                changeData("roadCondition", "null");
                changeData("roadConditionObject", {
                  label: "不分",
                  value: "null",
                });
                changeData("latest", "DATE", true);
              }}
            >
              清空查詢
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}
